import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOComponent = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url, 
  type = 'website',
  author = 'Pertubuhan Kebajikan Shan De',
  structuredData = null
}) => {
  const defaultTitle = 'Shan De Children\'s Welfare Home | 善德儿童福利之家 | Charity Organization Johor Bahru';
  const defaultDescription = 'Pertubuhan Kebajikan SHANDE - Non-profit charity organization in Johor Bahru helping disadvantaged children since 2011. We accept children from all races regardless of religious beliefs.';
  const defaultKeywords = '善德儿童福利之家, Pertubuhan Kebajikan Shande, Johor Bahru charity, children welfare, non-profit organization, donate children, sponsor child, volunteer Malaysia, charity organization Malaysia, orphanage Johor';
  const defaultImage = 'https://www.shandejohor.org.my/assets/img/sdlogo.png';
  const siteUrl = 'https://www.shandejohor.org.my';

  const pageTitle = title ? `${title} | Shan De` : defaultTitle;
  const pageDescription = description || defaultDescription;
  const pageKeywords = keywords ? `${keywords}, ${defaultKeywords}` : defaultKeywords;
  const pageImage = image || defaultImage;
  const pageUrl = url ? `${siteUrl}${url}` : siteUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{pageTitle}</title>
      <meta name="title" content={pageTitle} />
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={pageKeywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={pageUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Shan De Children's Welfare Home" />
      <meta property="og:locale" content="en_MY" />
      <meta property="og:locale:alternate" content="zh_CN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={pageUrl} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOComponent;
